"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const removeNonDigits_1 = __importDefault(require("./removeNonDigits"));
function toNumber(stringValue) {
    if (typeof stringValue !== 'string')
        throw new Error('Non-string type in toNumber()');
    return Number((0, removeNonDigits_1.default)(stringValue));
}
exports.default = toNumber;
